import { render } from "./TheForgotPassword.vue?vue&type=template&id=446b956d&scoped=true&ts=true"
import script from "./TheForgotPassword.vue?vue&type=script&lang=ts"
export * from "./TheForgotPassword.vue?vue&type=script&lang=ts"

import "./TheForgotPassword.vue?vue&type=style&index=0&id=446b956d&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446b956d"]])

export default __exports__